export default function FeedCardSkeleton({ count = 4 }) {
  return (
    <ul className="feed-skeleton-list space-y-3" aria-busy="true" aria-label="Loading results">
      {Array.from({ length: count }, (_, i) => (
        <li
          key={i}
          className="feed-skeleton-card overflow-hidden rounded-xl border border-white/10 bg-slate-800/50 p-4 backdrop-blur-md"
        >
          <section className="flex gap-3">
            <span className="feed-skeleton-block h-12 w-12 shrink-0 rounded-xl" aria-hidden />
            <span className="min-w-0 flex-1 space-y-2">
              <span className="feed-skeleton-block block h-2.5 w-24 rounded" aria-hidden />
              <span className="feed-skeleton-block block h-4 w-[72%] max-w-xs rounded" aria-hidden />
              <span className="flex gap-1.5">
                <span className="feed-skeleton-block h-5 w-14 rounded-md" aria-hidden />
                <span className="feed-skeleton-block h-5 w-16 rounded-md" aria-hidden />
                <span className="feed-skeleton-block h-5 w-12 rounded-md" aria-hidden />
              </span>
            </span>
          </section>
          <span className="feed-skeleton-block mt-3 block h-1 w-full rounded-full" aria-hidden />
        </li>
      ))}
    </ul>
  );
}
